type LauncherButtonProps = {
  isOpen: boolean
  onClick: () => void
  disabled?: boolean
}

export function LauncherButton(props: LauncherButtonProps) {
  const { isOpen, onClick, disabled } = props

  const statusLabel = isOpen ? 'Close widget' : 'Open assistant'

  return (
    <button
      type="button"
      className="vnw-launcher"
      onClick={onClick}
      disabled={disabled}
      aria-label={statusLabel}
      title={statusLabel}
    >
      <span className="vnw-launcherIcon" aria-hidden="true">
        {isOpen ? (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M6 6l12 12M18 6L6 18"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
        ) : (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 14a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v5a3 3 0 0 0 3 3Z"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
            <path
              d="M19 11a7 7 0 0 1-14 0"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
            <path
              d="M12 18v3"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
        )}
      </span>
    </button>
  )
}

